import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default {
    init($element) {
    },

    finalize($element) {
        if ($element.find('.shared-full-width-banner-cta')) {
            const bannerTitle = $element.find('.section-title').get();
            const bannerDesc = $element.find('.section-description').get();
            const bannerBtn = $element.find('.btn').get();
            
            const elements = gsap.utils.toArray([bannerTitle, bannerDesc, bannerBtn]);

            gsap.fromTo(elements, {
                y: 20,
                autoAlpha: 0,
            }, {
                scrollTrigger: {
                    trigger: elements,
                    start: 'top bottom',
                },
                y: 0,
                autoAlpha: 1,
                stagger: 0.2,
                duration: 1,
                ease: 'power4.out',
            })
        }
    },
}


// WEBPACK FOOTER //
// ./scripts/partials/shared/fullWidthBannerCta.js